import { Directive, Input, ElementRef } from '@angular/core';
import { OauthHelper } from '../../services/webservice'
import { JwtHelper } from 'angular2-jwt';

@Directive({
	selector: '[hasRole]'
})
export class HasRole {
	@Input('hasRole') role: string;

	constructor(private el: ElementRef, private oauthHelper: OauthHelper, private jwtHelper: JwtHelper) {
		el.nativeElement.style.display = 'none';
	}

	ngOnInit() {
		let decodedToken = this.jwtHelper.decodeToken(this.oauthHelper.getAccessToken());
		let springRole = "ROLE_" + this.role
		for (let authority of decodedToken.authorities) {
			if (authority === springRole) {
				this.el.nativeElement.style.display = '';
				return;
			}
		}
		this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
	}
}




// WEBPACK FOOTER //
// ./src/app/ui-helper/hasRole/has-role.component.ts